<template>
    <v-modal name="jit-enable" :width="400" height="auto" close-button @before-open="beforeOpen"
        @opened="onModalOpened">
        <div class="jit-modal" :key="forceRerender">
            <h3 class="jit-modal__title">{{ $t('ENABLE_JIT_BUTTON') }}</h3>

            <div class="jit-modal__content">
                <p class="jit-modal__instruction" @click="close"
                    v-html="$t('JIT_MODAL_INSTRUCTION', { href: '/details/45a698af5360560fd8a522a8ebbc634da8f55df4' })" />
                <p class="jit-modal__subtitle">{{ $t('JIT_MODAL_FALLBACK_INSTRUCTION') }}</p>
                <p class="jit-modal__notice">
                    {{ $t('JIT_MODAL_ERROR_NOTICE') }}
                </p>
            </div>

            <div class="jit-modal__footer">
                <button class="g-button" @click="close">{{ $t('CLOSE') }}</button>
                <button class="g-button g-button_primary" @click="enableJit">{{ $t('ENABLE_JIT_BUTTON') }}</button>
            </div>
        </div>
    </v-modal>
</template>

<script>
import VModal from '@/components/VModal.vue';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
    components: {
        VModal,
        HtmlWithLinks,
    },
    data() {
        return {
            bundleId: null,
            forceRerender: 0,
        };
    },
    methods: {
        beforeOpen(event) {
            this.bundleId = event.params?.bundleId;
            // Force component re-render to ensure translations are loaded
            this.forceRerender += 1;
            console.log('JIT Modal beforeOpen - bundleId:', this.bundleId);
            console.log('JIT Modal beforeOpen - $t function available:', typeof this.$t);
            console.log('JIT Modal beforeOpen - ENABLE_JIT translation:', this.$t('ENABLE_JIT'));
        },
        onModalOpened() {
            // Automatically trigger JIT enabling when modal opens
            this.enableJit();
        },
        close() {
            this.$modal.hide('jit-enable');
        },
        enableJit() {
            if (this.bundleId) {
                window.location.href = `appdb.45a698af5360560fd8a522a8ebbc634da8f55df4://enable_jit=${this.bundleId}`;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.jit-modal {
    &__title {
        margin: 0 0 20px 0;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        color: var(--text-primary);
    }

    &__content {
        margin-bottom: 20px;
        line-height: 1.4;
    }

    &__instruction {
        margin-bottom: 15px;
        font-size: 16px;
        text-align: center;

        a {
            color: var(--primary);
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &__subtitle {
        margin-bottom: 15px;
        font-weight: 500;
        text-align: center;
    }

    &__notice {
        margin-bottom: 0;
        font-style: italic;
        font-size: 14px;
        color: var(--text-secondary);
        text-align: center;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid var(--tertiary-accent);
        padding-top: 15px;
    }
}
</style>